module.exports = __webpack_public_path__ + "img/23.d5e3751c.png";